// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3UIXS","tabsBox":"styles_tabsBox__Q5Npu","createButton":"styles_createButton__35_1-"};